// Quests
export const FETCH_QUESTS = 'FETCH_QUESTS';
export const FETCH_UPDATED_QUEST = 'FETCH_UPDATED_QUEST';
export const REQUEST_QUESTS = 'REQUEST_QUESTS';
export const RECEIVE_QUESTS = 'RECEIVE_QUESTS';
export const ALREADY_RECEIVE_QUESTS = 'ALREADY_RECEIVE_QUESTS';
export const REQUEST_QUEST = 'REQUEST_QUEST';
export const RECEIVE_QUEST = 'RECEIVE_QUEST';
export const NOT_RECEIVE_QUEST = 'NOT_RECEIVE_QUEST';
export const SEND_QUEST = 'SEND_QUEST';
export const APPROVE_QUEST = 'APPROVE_QUEST';
export const SYNC_QUEST_SUCCESS = 'SYNC_QUEST_SUCCESS';
export const SYNC_QUEST_FAILURE = 'SYNC_QUEST_FAILURE';
export const ADD_QUEST = 'ADD_QUEST';
export const EDIT_QUEST = 'EDIT_QUEST';
export const RENAME_QUEST = 'RENAME_QUEST';
export const SELECT_QUEST = 'SELECT_QUEST';
export const SYNC_QUEST = 'SYNC_QUEST';
export const FETCH_QUEST = 'FETCH_QUEST';
export const UPDATE_QUEST_DATA = 'UPDATE_QUEST_DATA';

export const COPY_QUEST = 'COPY_QUEST';
export const COPY_QUEST_SUCCESS = 'COPY_QUEST_SUCCESS';
export const COPY_QUEST_FAILURE = 'COPY_QUEST_FAILURE';

export const DELETE_QUEST = 'DELETE_QUEST';
export const DELETE_QUEST_UNDO = 'DELETE_QUEST_UNDO';
export const DELETE_QUEST_SUCCESS = 'DELETE_QUEST_SUCCESS';
export const DELETE_QUEST_FAILURE = 'DELETE_QUEST_FAILURE';

export const CREATE_QUEST = 'CREATE_QUEST';
export const CREATE_QUEST_SUCCESS = 'CREATE_QUEST_SUCCESS';
export const CREATE_QUEST_FAILURE = 'CREATE_QUEST_FAILURE';

export const TOGGLE_MUSEUM_SAGA = 'TOGGLE_MUSEUM_SAGA';
export const TOGGLE_MUSEUM = 'TOGGLE_MUSEUM';

// Events
export const ADD_EVENT = 'ADD_EVENT';
export const DELETE_EVENT = 'DELETE_EVENT';
export const DELETE_EVENT_SYNC = 'DELETE_EVENT_SYNC';
export const RENAME_EVENT = 'RENAME_EVENT';
export const EDIT_EVENT_GEO = 'EDIT_EVENT_GEO';
export const EDIT_EVENT_TIME = 'EDIT_EVENT_TIME';
export const SEND_FILES = 'SEND_FILES';
export const ADD_EVENT_IMAGES = 'ADD_EVENT_IMAGES';
export const RECEIVE_IMAGES_URLS = 'RECEIVE_IMAGES_URLS';
export const NOT_RECEIVE_IMAGES_URLS = 'NOT_RECEIVE_IMAGES_URLS';
export const REMOVE_EVENT_IMAGE = 'REMOVE_EVENT_IMAGE';
export const REMOVE_EVENT_IMAGES = 'REMOVE_EVENT_IMAGES';
export const REPLACE_EVENT_IMAGE = 'REPLACE_EVENT_IMAGE';
export const DRAG_EVENT_IMAGE = 'DRAG_EVENT_IMAGE';
export const SYNC_DRAG_EVENT_IMAGE = 'SYNC_DRAG_EVENT_IMAGE';
export const EDIT_EVENT_DIRECTIONS = 'EDIT_EVENT_DIRECTIONS';

export const UPDATE_EVENT_IMAGE_DESCRIPTION = 'UPDATE_EVENT_IMAGE_DESCRIPTION';
export const RECEIVE_VIDEOS_URLS = 'RECEIVE_VIDEOS_URLS';
export const REMOVE_EVENT_VIDEO = 'REMOVE_EVENT_VIDEO';
export const RECEIVE_IMAGEAR_URL = 'RECEIVE_IMAGEAR_URL';
export const EDIT_EVENT_AR = 'EDIT_EVENT_AR';
export const REMOVE_AR_TARGET = 'REMOVE_AR_TARGET';
export const ADD_EVENT_AUDIOS = 'ADD_EVENT_AUDIOS';
export const RECEIVE_AUDIOS_URLS = 'RECEIVE_AUDIOS_URLS';
export const NOT_RECEIVE_AUDIOS_URLS = 'NOT_RECEIVE_AUDIOS_URLS';
export const REMOVE_EVENT_AUDIO = 'REMOVE_EVENT_AUDIO';
export const EDIT_EVENT_AUDIOS = 'EDIT_EVENT_AUDIOS';
export const EDIT_EVENT_AUDIO_HTML = 'EDIT_EVENT_AUDIO_HTML';
export const EDIT_EVENT_TEXT = 'EDIT_EVENT_TEXT';
export const EDIT_EVENT_HTML = 'EDIT_EVENT_HTML';
export const EDIT_EVENT_CHOICE = 'EDIT_EVENT_CHOICE';
export const CHANGE_TITLE = 'CHANGE_TITLE';
export const EDIT_EVENT_HINTS = 'EDIT_EVENT_HINTS';
export const EDIT_EVENT_SKIP = 'EDIT_EVENT_SKIP';
export const EDIT_EVENT_BONUS = 'EDIT_EVENT_BONUS';
export const RECEIVE_STICKERS_URL = 'RECEIVE_STICKERS_URL';
export const REMOVE_EVENT_STICKER = 'REMOVE_EVENT_STICKER';
export const REORDER_EVENT_STICKER = 'REORDER_EVENT_STICKER';
export const REORDER_EVENTS_AND_POINTS = 'REORDER_EVENTS_AND_POINTS';
export const REORDER_EVENTS = 'REORDER_EVENTS';

// Routes
export const ADD_ROUTE_POINT = 'ADD_ROUTE_POINT';
export const EDIT_ROUTE_POINT = 'EDIT_ROUTE_POINT';
export const REMOVE_ROUTE_POINT = 'REMOVE_ROUTE_POINT';
export const REARRANGE_ROUTE_POINTS = 'REARRANGE_ROUTE_POINTS';
export const MERGE_ROUTE_POINTS = 'MERGE_ROUTE_POINTS';
export const SPLIT_ROUTE_POINT = 'SPLIT_ROUTE_POINT';
export const ADD_ROUTE_POINT_WITH_EVENT = 'ADD_ROUTE_POINT_WITH_EVENT';
export const RENAME_ROUTE_POINT_WITH_EVENT = 'RENAME_ROUTE_POINT_WITH_EVENT';
export const SEND_ROUTE_POINT = 'SEND_ROUTE_POINT';
export const SEND_ROUTE_POINT_FAILURE = 'SEND_ROUTE_POINT_FAILURE';
export const SEND_ROUTE_POINT_SUCCESS = 'SEND_ROUTE_POINT_SUCCESS';
